import PrintAllPagesStaticModal from "./PrintAllPagesStaticModal";

export default PrintAllPagesStaticModal;
